import { BellIcon } from 'lucide-react';

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';

import { useInboxStore } from '../alerts/store';
import { badgeText } from '../badgeText';
import { useUnreadCount } from '../hooks/useUnreadCount';
import { InboxPanel } from './InboxPanel';

/**
 * The bell (spec 131 US1). It returns now that something produces
 * notifications; it was removed while nothing did (`Topbar.tsx`). The count
 * covers every workspace, so something waiting elsewhere is never hidden.
 */
export function NotificationBell() {
  const unread = useUnreadCount();
  // In a store, so an alert's "+n more" can open the inbox too (spec 136).
  const open = useInboxStore((state) => state.open);
  const setOpen = useInboxStore((state) => state.setOpen);
  const count = unread ?? 0;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger
        aria-label={
          count > 0 ? `Notifications, ${String(count)} unread` : 'Notifications'
        }
        className="text-muted-foreground hover:bg-accent hover:text-foreground focus-visible:ring-ring relative flex size-8 items-center pointer-coarse:size-11 justify-center rounded-md transition-colors focus-visible:ring-3 focus-visible:outline-none"
      >
        <BellIcon aria-hidden="true" className="size-4" strokeWidth={1.5} />
        {count > 0 ? (
          <span
            aria-hidden="true"
            className="bg-primary text-primary-foreground absolute -top-0.5 -right-0.5 min-w-4 rounded-full px-1 text-center text-2xs leading-4 font-medium tabular-nums"
          >
            {badgeText(count)}
          </span>
        ) : null}
      </PopoverTrigger>
      <PopoverContent align="end" className="p-0">
        <InboxPanel
          unread={unread}
          onNavigate={() => {
            setOpen(false);
          }}
        />
      </PopoverContent>
    </Popover>
  );
}
